import { createSlice } from '@reduxjs/toolkit';

export const FLOW_TYPES = {
  HAIR_TEST:         'hair_test',
  SKIP_HAIR_TEST:    'skip_hair_test',
  BOOK_CONSULTATION: 'book_consultation',
};

const flowSlice = createSlice({
  name: 'flow',
  initialState: {
    flowType: '',
    questionnaire: {
      selectedStage:  null,
      dateOfBirth:    '',
      menopauseState: '',
    },
  },
  reducers: {
    setFlowType(state, action) {
      state.flowType = action.payload;
      sessionStorage.setItem('flowType', action.payload);
    },
    setQuestionnaireData(state, action) {
      state.questionnaire = { ...state.questionnaire, ...action.payload };
      sessionStorage.setItem('questionnaireData', JSON.stringify(state.questionnaire));
    },
    clearFlowState(state) {
      state.flowType = '';
      state.questionnaire = { selectedStage: null, dateOfBirth: '', menopauseState: '' };
      sessionStorage.removeItem('flowType');
      sessionStorage.removeItem('questionnaireData');
    },
  },
});

export const { setFlowType, setQuestionnaireData, clearFlowState } = flowSlice.actions;
export default flowSlice.reducer;
